<template>
    
    <div class="expert_schedule max-content">
       <detail-537 v-if="meeting_id==537"></detail-537>
        <div v-else>
        <top title="专家日程" :color="theme_color"></top>
        <div class="expertInfo">
            <img v-if="expertInfo.photo" :src="expertInfo.photo" alt="" onerror="common.imgError(1,event)">
            <img v-else src="@/assets/images/defaultHead.png" alt="" >
            <div class="info_con flex">
                <div class="info">
                    <span>{{expertInfo.name}}</span>
                    <p v-if="meeting_id!=581">{{expertInfo.company}}</p>
                </div>
                <router-link v-if="meeting_id!=527 && meeting_id!=787 && meeting_id!=678" class="home_icon flex " :style="{'background':schedule_color,'color':schedule_font_color}" :to="{path:'/vascularNews/expert/index',query:{writer_id:writer_id,meeting_id:meeting_id}}">
                   专家主页
                </router-link>
            </div>
        </div>
        <van-tabs v-model="outer_active">
            <van-tab title="专家日程">
  

        <div class="scheduleCon" :class="expertInfo.task_book_url?'pd_b':''">
            <div class="channellist">
                <div class="channelblock"  v-for="(item,key) in dateTime" :key="key" @click="changeParentTabs(key)" >
                    <span :class="key==active?'active':''" :style="{background:key==active && theme_color?theme_color:''}">{{key}}</span>
                </div>
            </div>
            <table border="1px solid #efefef" >
                <tr class="schedule-head" :style="{'background':schedule_color,'color':schedule_font_color}">
                    <th width="16.67%" v-if="meeting_id==527">专场时间</th>
                    <th width="16.67%" v-if="meeting_id!=527">时间</th>
                    <th width="18.67%">会场</th>
                    <th width="17.67%">{{meeting_id==527?'板块':'会议主题'}}</th>
                    <th width="17.67%" v-if="meeting_id==527">任务时间</th>
                    <th width="16.67%">{{meeting_id==527?'内容':'任务'}}</th>
                    <th width="18.67%" v-if="meeting_id!=527">讲题</th>
                    <th width="11.67%" v-if="meeting_id!=527">日程</th>
                </tr>
                <tbody>
                    <tr v-for="(val) in tableData" :key="val.cdw_id" class="schedule-content">
                        <td v-if="meeting_id==527">{{(val.chapter_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.chapter_end_at.split(' ')[1]).slice(0,5)}}</td>
                        <td v-if="meeting_id!=527">
                            <p v-if="!val.detail_name"><b>{{(val.chapter_start_at.split(' ')[0]).slice(5)}}</b><br/>{{(val.chapter_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.chapter_end_at.split(' ')[1]).slice(0,5)}}</p>
                            <p v-if="val.detail_name"><b>{{(val.detail_start_at.split(' ')[0]).slice(5)}}</b><br/>{{(val.detail_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.detail_end_at.split(' ')[1]).slice(0,5)}}</p>
                        </td>
                        <td ><p>{{val.session_name}}</p><p style="margin-top: 10px;">{{ val.hall_name || ''}}</p> </td>
                        <td>{{val.chapter_name}}</td>
                        <td v-if="meeting_id==527">
                            <p v-if="!val.detail_name">{{(val.chapter_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.chapter_end_at.split(' ')[1]).slice(0,5)}}</p>
                            <p v-if="val.detail_name">{{(val.detail_start_at.split(' ')[1]).slice(0,5)}}<br/> - <br/>{{(val.detail_end_at.split(' ')[1]).slice(0,5)}}</p>
                        </td>
                        <td>{{val.title}}</td>
                        <td v-if="meeting_id!=527">{{val.detail_name}}</td>
                        <td v-if="meeting_id!=527" width="30px">
                            <p style="display: flex;flex-direction: column;justify-content: center;align-items: center;gap:4px" v-if="val.live_status!=3 && val.is_show_schedule && val.is_show_live==1 "><img src="../../../assets/images/System/play_icon.png" v-if="meeting_id!=473" @click="goLive(val.meeting_id,val.session_id)"/><span>播放</span></p>
                            <p style="display: flex;flex-direction: column;justify-content: center;align-items: center;gap:4px"  v-if="val.live_status==3 || (val.live_status!=3 && !val.is_show_schedule)"><img src="../../../assets/images/System/search_icon.png" v-if="meeting_id!=473" @click="goSchedule(val)"/><span>查询</span></p>
                        </td>
                        

                    </tr>
                </tbody>
            </table>
        </div>
        </van-tab>
        <van-tab title="专家简介" v-if="expertInfo.des">
            <p class="description" :class="expertInfo.task_book_url?'pd_b':''">{{expertInfo.des}}</p>
        </van-tab>
        <van-tab title="" v-else :disabled="true">
            
        </van-tab>
        </van-tabs>
        </div>
        <div class="downPdf" v-if="expertInfo.task_book_url" @click="downPdf" :style="{'background':theme_color}">
            <img src="https://cdn.edstatic.com/203012120000/9213e4194210771fb71bf0dd1d5f8428/2025/07/a641924e-77f6-452c-a460-3ea7a6867eb5.png" alt="">
            <p>下载专家任务书</p>
        </div>
        
    </div>
</template>
<script>
	import {ExpertInformation,ExpertSchedule,MeetingsDetails} from '../../../config/interface.js'
    import Top from '../components/Top'
    import detail537 from './Detail537.vue'
    export default{
        components:{
            Top,
            detail537
        },
        data(){
            return{
                outer_active:0,
                active:1,
                writer_id:0,
                meeting_id:0,
                dateTime:{},
                parent_id:'',
                scheduleData:{},
                tableData:{},
                expertInfo:{},
                theme_color:'',
                schedule_color:'rgb(243, 217, 217)',//表头文字底色
                schedule_font_color:'brown',//表头文字颜色
                
            }
        },
        mounted(){
            this.meeting_id=this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id;
            this.writer_id=this.$route.query.writer_id?this.$route.query.writer_id:this.$route.query.w_id;
            this.getExpertInfo();
            this.querySchedule();
            if(this.meeting_id==473){
                this.theme_color='#0A318E'
            }
        },
        methods:{
            //专家信息
			getExpertInfo(id){
				const url=ExpertInformation;
				const method='POST';
				let params={
					writer_id:this.writer_id,
                    meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.expertInfo={
							photo:data.photo,
							name:data.name,
							company:data.company,
                            title:data.title['name'],
							positionName:data.title.name,
							des:data.des,
                            task_book_url:data.task_book_url
						}
                        if(data.theme_color){
                            this.theme_color=data.theme_color;
                        }
                        if(data.schedule_color){
                            this.schedule_color=data.schedule_color;
                        }
                        if(data.schedule_font_color){
                            this.schedule_font_color=data.schedule_font_color;
                        }
                        if(common.is_weixin()){
                            this.setShare(data.name);
						}
					}
				})
			},
            setShare(name){
                const url=MeetingsDetails;
				const method='POST';
				let params={
					meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
                        let data=res.data;
						// this.meeting_dates=data.meeting_dates;
						//微信浏览器  请求jsdk
						if(common.is_weixin()){
							common.wxShare(name+'的个人主页','请点击查看',data.shareimg);
						}
					}
				})

            },
            //日程
            querySchedule(){
                const url=ExpertSchedule;
				const method='POST';
				let params={
					writer_id:this.writer_id,
                    meeting_id:this.meeting_id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
                        this.scheduleData=data;
                        let dateArr= Object.keys(data);
                        if(this.meeting_id==527){
                            dateArr.shift() // 删除第一个元素
                        }
                        this.tableData=data[dateArr[0]]['全部'];
                        this.parent_id=dateArr[0];
                        this.active=dateArr[0];
                        dateArr.forEach((item,index)=>{;
                            this.$set(this.dateTime,item,Object.keys(data[item])[0]);
                        })
                        console.log(dateArr,this.dateTime);
					}
				})
            },
            changeParentTabs(val){
                console.log(val,this.scheduleData)
                this.tableData=this.scheduleData[val]['全部'];
                this.active=val;
            },
            changeChildTabs(value){
                this.dateTime[this.parent_id]=value;
            },
            goLive(meeting_id,session_id){
                this.$router.push({
                    path:'/vascularNews/meeting/liveDetail',
                    query:{'meeting_id':meeting_id,
                    'id':session_id}
                })

            },
            goSchedule(val) {
                localStorage.setItem("schedule_date", val.start_date);
                this.$router.push({
                    path: '/vascularNews/meeting/scheduleList',
                    query: {
                        'meeting_id': val.meeting_id,
                        'id': val.session_id,
                        'chapter_id': val.chapter_id

                    }
                })
            },
            downPdf(){
                if(this.expertInfo.task_book_url){
                    console.log('专家任务书',this.expertInfo.task_book_url)
                   window.open(this.expertInfo.task_book_url);
                }
            },
            formatSessionName(name){
                let strs=name.split(' ');
                let str='';
                for(let i=0;i<strs.length;i++){
                    str=str+strs[i]+"<br/>";
                }
                return str;

            }
        }
    }
</script>
<style scoped lang="scss">
    .expert_schedule{
        width:100%;
        height: 100%;
        background:#f4f4f4;
        .expertInfo{
            padding:10px 20px;
            display: flex;
            background:#fff;
            img{
                width:100px;
                height: 100%;
            }
            .home_icon{
                align-items: center;
                font-size: 13px;
                color:$color-main;
                height:25px;
                width:80px;
                text-align: center;
                line-height: 25px;
                border-radius: 12.5px;
                display:block;
                i{
                    font-size:16px;
                    margin-right:3px;
                }
            }
            .info_con{
                flex:1;
                padding: 5px 10px;
                flex-direction: column;
                justify-content: space-between;
                .info{
                    span{
                        font-size:14px;
                        font-weight: bold;

                    }
                    p{
                        color:#666;
                    }
                }
            }
        }
        .scheduleCon{
            padding-top:15px;
            background:#f4f4f4 ;
            margin-bottom:20px ;
        }
        .channellist{
            margin:10px;
            display: flex;
            flex-wrap: wrap;
            .channelblock{
                margin-left:2% ;
                margin-bottom:5px ;
                border-radius: 5px;
                width:23%;
                white-space:nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
                span{
                    display: block;
                    // width:80px;
                    // height: 30px;
                    line-height: 30px;
                    background:#fff;
                    color:$color-gray;
                    font-size:13px;
                    text-align: center;
                    padding:  0 3px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
                span.active{
                    color:#fff;
                    background:$color-main;
                }
            }
        }
        table{
            text-align: center;
            border: 1px solid rgb(209, 196, 196);
            border-collapse: collapse;
            margin: 0 15px 20px 15px;
            th{
            //    background: rgb(243, 217, 217);
                font-size:12px;
                // color: brown;
                // width:16.67%;
                height: 30px;
                border: 1px solid rgb(209, 196, 196);
            }
            tr{
                font-size:12px;
                background: white;
                border: 1px solid rgb(209, 196, 196);
                td{
                    // width:16.67%;
                    border: 1px solid rgb(209, 196, 196);
                    word-break:break-all;
                      img{
                    width:22px;
                    height:22px;
                }
            }
                }
        }
        .description{
            margin:20px;
            font-size:15px;
            line-height: 30px;
            color:$color-gray;
            white-space: pre-wrap;
        }
    }
    .downPdf{
        position: fixed;
        width: 90%;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: 20px;
        z-index: 9;
        display: flex;
        align-items: center;
        color: #fff;
        justify-content: center;
        gap: 10px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        font-size: 14px;
        img{
            width: 16px;
            height: auto;
        }
        
    }
    .pd_b{
        padding-bottom: 80px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Expert/Detail.vue